export const LIBRARY_EVENT_NAMES = {
    VIEW_MODE: {
        ALL: 'Viewed All Folders Page',
        ARCHIVED: 'Viewed Archived Folders Page',
        OWNED: 'Viewed My Folders Page',
        SHARED: 'Viewed Shared Folders Page',
    },
    FOLDER_ACTION: {
        CLICKED_EDIT_FOLDER: 'Clicked Edit Folder Button',
        CLICKED_DELETE_FOLDER: 'Clicked Delete Folder Button',
        CLICKED_SHARE_FOLDER: 'Clicked Share Folder',
        CLICKED_ARCHIVE_FOLDER: 'Clicked Archive Folder',
        CLICKED_UNARCHIVE_FOLDER: 'Clicked Unarchive Folder',
        CLICKED_SEND_SHARED_FOLDER_INVITATION: 'Clicked Send Shared Folder Invitation',
        ATTEMPTED_OPEN_ARCHIVE_FOLDER: 'Attempted Open Archive Folder',
        REMOVED_FOLDER_USER: 'Removed Folder User',
        CLICKED_ADD_FOLDER: 'Clicked Add Folder',
        OPENED_SHARE_FOLDER_MODAL: 'Opened Share Folder Modal'
    },
    SAVE_TO_LIBRARY: {
        GOAL: 'Clicked Save Goal to Library',
        STRATEGY: 'Clicked Save Strategy to Library',
        PRESENT_LEVELS: 'Clicked Save Present Levels to Library',
        COPIED_TO_ANOTHER_FOLDER: 'Copied Present Levels to Another Folder'
    },
    REVEALED_CONTRIBUTOR_TOOLTIP: 'Revealed Contributor Tooltip'
}
